import { ComponentType } from 'react';

const enGBComponents: Record<string, ComponentType> = {};

export default enGBComponents;
